import _DatabaseModel from "./_DatabaseModel";

const PRICE_LISTS_TAB_ITEMS = 122;

class PriceList extends _DatabaseModel {
  static model = "price_list";
  static showSize = 8;
  static editDialogComponent = "price-lists-edit-dialog";

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { text: "", value: "tags", sortable: false },
    { textKey: "price_list.label.valid_from", value: "valid_from" },
    { textKey: "price_list.label.valid_to", value: "valid_to" },
  ];

  static show = {
    buttons: ["edit"],

    reloadingModels: ["price_items_price_list"],
  };

  static filter = {
    parts: {
      fields: ["name", "description", "time_filter", "currency"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static operations = ["report"];

  static currencies = ["EUR", "USD", "GBP", "CHF", "CZK"];

  static cardFields(object) {
    return {
      title: object.name,
      subtitle: object.currency,
      tags: true,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "price_list.label.currency",
        value: object.currency,
        type: "plain",
      },
      {
        labelKey: "price_list.label.valid_from",
        value: object.valid_from,
        type: "date",
      },
      {
        labelKey: "price_list.label.valid_to",
        value: object.valid_to,
        type: "date",
        display_unset: true,
      },
      {
        labelKey: "form.label.owner",
        value: object.owner?.person,
        type: "link",
        to: "persons",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    this.commonActions.permittedPersons,
    this.commonActions.export,
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "price_item.price_items",
      permission: PRICE_LISTS_TAB_ITEMS,
      component: "PriceItemsPriceListsTab",
      disabled: this.defaultDisabledTab(),
    },
  ];
}

export default PriceList;
